import React, { useState } from 'react';
import $ from 'jquery';

import {
    AD_ENTITY_TYPES,
    DEFAULT_MASK,
    FIRST_OCTET_PATTERN,
    MASK_PATTERN,
    OCTET_PATTERN
} from '@silverfort-nodelibs/common/utils/consts';

import styles from './css/IpInputContainer.module.css';
import { isIpSubnetValid } from '../../../utils';

const IP_PARTS_TO_FIELDS_DATA = [
    { type: 'input', key: 'ipPartOne', placeholder: '192' },
    { type: 'span', value: '.' },
    { type: 'input', key: 'ipPartTwo', placeholder: '168' },
    { type: 'span', value: '.' },
    { type: 'input', key: 'ipPartThree', placeholder: '55' },
    { type: 'span', value: '.' },
    { type: 'input', key: 'ipPartFour', placeholder: '12' },
    { type: 'span', value: '/', isMask: true },
    { type: 'input', key: 'mask', placeholder: DEFAULT_MASK, isMask: true }
];

const IpInputContainer = ({
    disableNetMasks,
    addIp,
    showExcluded,
    maxIps,
    disabledAdd = false,
    disableAutoComplete
}) => {
    const [ipParts, setIpParts] = useState({ ipPartOne: '', ipPartTwo: '', ipPartThree: '', ipPartFour: '', mask: '' });
    const [isValidIP, setIsValidIP] = useState(false);
    const [ipAddFailed, setIpAddFailed] = useState(false);

    const onAddressChanged = (event) => {
        setIpAddFailed(false);
        const newValue = event.target.value;
        const ipPart = event.target.name;
        const isEmptyValue = newValue === '';
        const isIpValid = ipPart === 'ipPartOne' ? FIRST_OCTET_PATTERN.test(newValue) : OCTET_PATTERN.test(newValue);

        if (
            ((isEmptyValue || isIpValid) &&
                ['ipPartOne', 'ipPartTwo', 'ipPartThree', 'ipPartFour'].includes(event.target.name)) ||
            (MASK_PATTERN.test(newValue) && event.target.name === 'mask')
        ) {
            const newIpParts = { ...ipParts, [event.target.name]: newValue };
            setIpParts(newIpParts);
            setIsValidIP(
                isIpSubnetValid(
                    `${newIpParts.ipPartOne}.${newIpParts.ipPartTwo}.${newIpParts.ipPartThree}.${newIpParts.ipPartFour}`,
                    newIpParts.mask
                )
            );
            if (newValue.length === 3) $(event.target).next().next().select();
        } else {
            event.preventDefault();
            if (
                (event.target.value[event.target.selectionStart - 1] === '.' &&
                    ['ipPartOne', 'ipPartTwo', 'ipPartThree'].includes(event.target.name)) ||
                (event.target.value[event.target.selectionStart - 1] === '/' && event.target.name === 'ipPartFour')
            ) {
                $(event.target).next().next().select();
            }
        }
    };

    const onAddIpClicked = (excluded) => {
        if (isValidIP && !disabledAdd) {
            const address = `${ipParts.ipPartOne}.${ipParts.ipPartTwo}.${ipParts.ipPartThree}.${ipParts.ipPartFour}`;
            const newIp = {
                name: address,
                address: address,
                mask: ipParts.mask || DEFAULT_MASK,
                excluded: excluded,
                type: AD_ENTITY_TYPES.IP
            };
            const isAdded = addIp(newIp);
            if (isAdded) {
                setIpParts({ ipPartOne: '', ipPartTwo: '', ipPartThree: '', ipPartFour: '', mask: '' });
                setIsValidIP(false);
            } else {
                setIpAddFailed(true);
            }
        }
    };

    const handlePaste = (event) => {
        const subnet = event.clipboardData.getData('Text');
        const ip = subnet.split('/')[0];
        const mask = subnet.split('/')[1] || '';
        if (isIpSubnetValid(ip, mask)) {
            event.preventDefault();
            const ipSplited = ip.split('.');
            setIpParts({
                ipPartOne: ipSplited[0],
                ipPartTwo: ipSplited[1],
                ipPartThree: ipSplited[2],
                ipPartFour: ipSplited[3],
                mask: mask
            });
            setIsValidIP(true);
        }
    };

    const ipInputParts = IP_PARTS_TO_FIELDS_DATA.filter((ipPart) => {
        return disableNetMasks ? !ipPart.isMask : true;
    }).map((ipPart, index) => {
        if (ipPart.type === 'input') {
            return (
                <input
                    key={`ipPart_${index}`}
                    value={ipParts[ipPart.key]}
                    name={ipPart.key}
                    className={styles.ipPart}
                    type="text"
                    onChange={(event) => {
                        onAddressChanged(event);
                    }}
                    onPaste={handlePaste}
                    placeholder={ipPart.placeholder}
                    onKeyPress={(event) => event.key === 'Enter' && onAddIpClicked()}
                    autoFocus={index === 0}
                    autoComplete={disableAutoComplete ? 'off' : undefined}
                />
            );
        }
        return <span key={`ipPart_${index}`}>{ipPart.value}</span>;
    });

    return (
        <div className={styles.newIpContainer}>
            {ipInputParts}
            <div className={styles.ipButtons}>
                <div
                    disabled={!isValidIP || disabledAdd}
                    onClick={() => onAddIpClicked(false)}
                    className={styles.ipAddButton}>
                    <i className="fa fa-plus-circle"></i> <span>Add</span>
                </div>
                {showExcluded && (
                    <div disabled={!isValidIP} onClick={() => onAddIpClicked(true)} className={styles.ipExcludeButton}>
                        <i className="fa fa-minus-circle"></i> <span>Exclude</span>
                    </div>
                )}
                {ipAddFailed && <div className={styles.ipAddFailed}>{'IP already selected'}</div>}
                {disabledAdd && maxIps && (
                    <div
                        className={styles.ipAddFailed}>{`Each configuration supports a maximum of ${maxIps} IPs.`}</div>
                )}
            </div>
        </div>
    );
};

export default IpInputContainer;
